import { render, staticRenderFns } from "./PenaltyFilterGroup.vue?vue&type=template&id=106c9be4&scoped=true&"
import script from "./PenaltyFilterGroup.vue?vue&type=script&lang=js&"
export * from "./PenaltyFilterGroup.vue?vue&type=script&lang=js&"
import style0 from "./PenaltyFilterGroup.vue?vue&type=style&index=0&id=106c9be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c9be4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCol,VDivider,VRow,VSelect,VSpacer})
